// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__ApQgZ","children":"Layout_children__EUgL5"};